import {Component, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {RefModelStoreService} from '@q9elements/ui-kit/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public showLoader = true;
  public isStripped: boolean;

  constructor(
    private router: Router,
    private rmeStore: RefModelStoreService
  ) {
    router.events.subscribe(evt => {
      if (evt instanceof NavigationStart) {
        /** Handle navigation start */
      } else if (evt instanceof NavigationEnd) {
        this.showLoader = false;
      }
    });
  }

  ngOnInit() {
    this.rmeStore.anchorTarget = window.self == window.top ? '_blank' : '_self';
    if (window.location.search.includes('stripped')) {
      this.rmeStore.isStripped = true;
      this.isStripped = true;
    }
  }
}
